import { render } from "./HomeScreen.vue?vue&type=template&id=34817e8c&scoped=true"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"

import "./HomeScreen.vue?vue&type=style&index=0&id=34817e8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34817e8c"]])

export default __exports__